import { render } from "./SplitJob.vue?vue&type=template&id=2e939713"
import script from "./SplitJob.vue?vue&type=script&lang=js"
export * from "./SplitJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__